type LogArgs = unknown[];

const clientLoggingEnabled =
  import.meta.env.DEV || import.meta.env.VITE_ENABLE_CLIENT_LOGS === 'true';

export const appLogger = {
  warn: (...args: LogArgs) => {
    if (clientLoggingEnabled) console.warn(...args);
  },
  error: (...args: LogArgs) => {
    if (clientLoggingEnabled) console.error(...args);
  },
};
